/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { POAMItemDto } from './POAMItemDto';
import {
    POAMItemDtoFromJSON,
    POAMItemDtoFromJSONTyped,
    POAMItemDtoToJSON,
    POAMItemDtoToJSONTyped,
} from './POAMItemDto';
import type { POAMMetadataDto } from './POAMMetadataDto';
import {
    POAMMetadataDtoFromJSON,
    POAMMetadataDtoFromJSONTyped,
    POAMMetadataDtoToJSON,
    POAMMetadataDtoToJSONTyped,
} from './POAMMetadataDto';

/**
 * 
 * @export
 * @interface POAMDto
 */
export interface POAMDto {
    /**
     * 
     * @type {string}
     * @memberof POAMDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMDto
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMDto
     */
    importSspId?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMDto
     */
    title?: string;
    /**
     * 
     * @type {POAMMetadataDto}
     * @memberof POAMDto
     */
    metadata?: POAMMetadataDto;
    /**
     * 
     * @type {string}
     * @memberof POAMDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMDto
     */
    priority?: string;
    /**
     * 
     * @type {Array<POAMItemDto>}
     * @memberof POAMDto
     */
    poamItems?: Array<POAMItemDto>;
    /**
     * 
     * @type {Date}
     * @memberof POAMDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof POAMDto
     */
    updated?: Date;
    /**
     * 
     * @type {number}
     * @memberof POAMDto
     */
    budget?: number;
}

/**
 * Check if a given object implements the POAMDto interface.
 */
export function instanceOfPOAMDto(value: object): value is POAMDto {
    return true;
}

export function POAMDtoFromJSON(json: any): POAMDto {
    return POAMDtoFromJSONTyped(json, false);
}

export function POAMDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'importSspId': json['importSspId'] == null ? undefined : json['importSspId'],
        'title': json['title'] == null ? undefined : json['title'],
        'metadata': json['metadata'] == null ? undefined : POAMMetadataDtoFromJSON(json['metadata']),
        'status': json['status'] == null ? undefined : json['status'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'poamItems': json['poamItems'] == null ? undefined : ((json['poamItems'] as Array<any>).map(POAMItemDtoFromJSON)),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'budget': json['budget'] == null ? undefined : json['budget'],
    };
}

export function POAMDtoToJSON(json: any): POAMDto {
    return POAMDtoToJSONTyped(json, false);
}

export function POAMDtoToJSONTyped(value?: POAMDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'importSspId': value['importSspId'],
        'title': value['title'],
        'metadata': POAMMetadataDtoToJSON(value['metadata']),
        'status': value['status'],
        'priority': value['priority'],
        'poamItems': value['poamItems'] == null ? undefined : ((value['poamItems'] as Array<any>).map(POAMItemDtoToJSON)),
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'budget': value['budget'],
    };
}

